import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import cn from 'classnames';

import styles from './styles.module.scss';

const Link = ({ children, href, to, className, colorType, ...props }) => {
  return (
    <RouterLink
      className={cn(styles.link, styles[colorType], className)}
      to={to || href}
      {...props}
    >
      {children}
    </RouterLink>
  );
};

export default Link;
